// frontend/src/components/Layout/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import authService from '../../services/authService';

const AppNavbar = () => {
    const [currentUser, setCurrentUser] = useState(undefined);
    const navigate = useNavigate();

    useEffect(() => {
        const userSession = authService.getCurrentUser();
        if (userSession) {
            setCurrentUser(userSession.user);
        }
    }, []);

    const handleLogout = () => {
        authService.logout();
        setCurrentUser(undefined);
        navigate('/login');
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
            <Link className="navbar-brand" to={currentUser ? "/home" : "/"}>Office App</Link>
            <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav mr-auto">
                    {currentUser && (
                        <li className="nav-item">
                            <Link className="nav-link" to="/home">Home</Link>
                        </li>
                    )}
                    {currentUser && currentUser.role === 'admin' && (
                         <li className="nav-item">
                            <Link className="nav-link" to="/admin">Admin</Link>
                        </li>
                    )}
                    {/* Add other common navigation links here if needed */}
                </ul>
                <ul className="navbar-nav ml-auto">
                    {currentUser ? (
                        <>
                            <li className="nav-item">
                                <span className="navbar-text mr-3">
                                    Logged in as: {currentUser.username} ({currentUser.role})
                                </span>
                            </li>
                            <li className="nav-item">
                                <button className="btn btn-outline-light" onClick={handleLogout}>
                                    Logout
                                </button>
                            </li>
                        </>
                    ) : (
                        <li className="nav-item">
                            <Link className="nav-link" to="/login">Login</Link>
                        </li>
                    )}
                </ul>
            </div>
        </nav>
    );
};

export default AppNavbar;